<template>
  <div>
    <Navigation/>
    <img :src="imgUrl" alt="" class="banner">
    <!-- 产品介绍 -->
    <div class="product_box">
      <img src="@/assets/product/productTitle1.png" alt="" class="title">
      <ul class="list flex">
        <li class="list_li" v-for="(item, index) in list" :key="index" @click="goView(index)">
          <img :src="item.imgUrl" alt="">
          <p class="list_li_title">{{ item.title }}</p>
          <div class="op">
            <span>{{ item.title }}</span>
            <span>{{ item.op_p }}</span>
            <span>{{ item.op_p2 }}</span>
            <span>{{ item.op_p3 }}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="partner">
      <div class="ct_box">
        <img class="title" src="../assets/product/productTitle2.png" alt="">
        <div class="line"></div>
        <div class="form_box flex">
          <el-select v-model="form.type" placeholder="请选择合作产品">
            <el-option v-for="(item, index) in options" :label="item.title" :key="index" :value="item.id">
            </el-option>
          </el-select>
          <el-input class="text" v-model="form.contacts" placeholder="输入联系人"></el-input>
          <el-input class="text" v-model="form.mobile" placeholder="输入联系电话"></el-input>
        </div>
        <el-input type="textarea" resize="none" v-model="form.des" maxlength="100"
                  :show-word-limit="true"></el-input>
        <el-button type="primary" @click="sub">提交</el-button>
      </div>
    </div>
    <footerBot/>
  </div>
</template>

<script>
import {goAi} from '@/util/goAi'
import {mapState} from 'vuex'

export default {
  name: '',
  computed: {
    ...mapState(['loginShow'])
  },
  created() {
  },
  mounted() {
    this.BannerImgFn()
  },
  data() {
    return {
      list: [
        {
          imgUrl: require('../assets/product/1.png'),
          title: '媒介投放',
          op_p: '精选线上万家媒介资源池：线上全网全覆盖，引爆全网无局限，提升全网曝光度与认可度，助力企业线上全网品牌建设。',
          op_p2: '一站式媒介投放，为企业品牌建设，招商、引流、宣传、背书，快速提高企业(品牌)曝光率及美誉度!让宣传更省钱、让范围更广泛、让形象更立体、让效果更直观。'
        },
        {
          imgUrl: require('../assets/product/7.png'),
          title: '广告投放',
          op_p: '精选线下广告资源位：线下区域全覆盖，引爆区域曝光度，提升区域认可度，助力企业线下区域品牌建设。',
          op_p2: '一站式广告投放，为企业品牌建设，招商、引流、宣传、背书，快速提高企业(品牌)曝光率及美誉度!让宣传更省钱、让范围更广泛、让形象更立体、让效果更直观。'
        },
        {
          imgUrl: require('../assets/product/9.png'),
          title: '红人经纪',
          op_p: '精选热门明星艺人，为您企业品牌提升知名度，全力打造品牌拓展闭环!',
          op_p2: '与多家经纪公司合力打造、提供全面的线上线下包装支持和服务协助。以“明星艺人粉丝效应”为切入点，助力企业明星形象形成双向共赢。',
        },
        //{
          //imgUrl: require('../assets/product/6.png'),
          //title: 'AI数字人',
          //op_p: 'AI数字人，想您所想!',
          //op_p2: '您是否曾为拍摄繁琐的视频无从下手?是否对拍摄成本的不断提升感到无力？不断学习进化的AI数字人，为您带来高效的体验，满足您的多方需求。',
        //},
        {
          imgUrl: require('../assets/product/3.png'),
          title: '视频拍摄',
          op_p: '高效拍摄：为您呈现完美的镜头。',
          op_p2: '专业剪辑：对视频进行精心的剪辑和包装，让作品更具吸引力。\n个性化定制：从题材选择到拍摄风格，我们都将竭诚为您服务。'
        },
        {
          imgUrl: require('../assets/product/2.png'),
          title: '技术开发',
          op_p: '用我们的技术力量，为您量身定制企业品牌数字化建设，打造您自己的数字城堡!',
          op_p2: '我们的专业团队将为您的网站、app和小程序提供全面的技术支持和研发更新服务。以“品牌视觉效果提升、营销数据精准分析”为切入点，助力企业形象形成完美闭环。',
        },
        //{
          //imgUrl: require('../assets/product/5.png'),
          //title: '可信网站',
          //op_p: '帮助网民核验网站身份，识别网站真假；',
          //op_p2: '权威机构评定验证帮助网站亮明真实身份；维护企业网站形象防范钓鱼网站；多平台信誉展示让网站流量变销量。',
        //},

        {
          imgUrl: require('../assets/product/4.png'),
          title: '智能生成',
          op_p: '智能生成，颠覆想象，想您所想！',
          op_p2: '您是否曾为写作困扰，苦思不得其解?是否曾因时间紧迫，难以完成大量文字工作?否曾为制作视频素材无从下手?不断学习进化的AI办公为您带来高效体验，满足您多方需求。',
          // op_p3: '不断学习进化的AI写作，为您带来全新的写作体验。',
        },

        // {
        //   imgUrl: require('../assets/product/8.png'),
        //   title: '享视界',
        //   op_p: '享视界，想您所想!',
        //   op_p2: '您是否曾为制作视频素材以及书写专业文书等工作无从下手?不断学习进化的AI办公，为您带来高效的体验，满足您的多方需求。',
        // },
      ],
      // 选项
      options: [{
        id: 1,
        title: '媒体发布'
      }, {
        id: 2,
        title: '技术开发'
      }, {
        id: 3,
        title: '视频制作',
      },
        {
          id: 4,
          title: '智能写作'
        },
        {
          id: 5,
          title: '可信认证'
        }
      ],
      form: {
        type: '', //类型
        contacts: '', //联系人名字
        mobile: '', //联系电话
        des: '', //留言
      },
      imgUrl: '',
      fullscreenLoading: false,
    }
  },
  methods: {
    BannerImgFn() {
      this.curlGet('/api/advert/detail', {
        mark: 'product_banner_01'
      }).then(res => {
        if (res.data.code) {
          this.imgUrl = res.data.data.image
        }
      })
    },
    sub() {
      this.fullscreenLoading = true
      this.curlPost('/api/cooperate/save', this.form).then(res => {
        console.log(res);
        this.fullscreenLoading = false
        if (res.data.code) {
          this.form = {
            type: '', //类型
            contacts: '', //联系人名字
            mobile: '', //联系电话
            des: '', //留言
          }
          setTimeout(() => {
            this.$message({
              offset: 80,
              type: 'success',
              message: '上传成功',
            })
          }, 100)
        } else {
          setTimeout(() => {
            this.$message({
              offset: 80,
              type: 'warning',
              message: res.data.msg,

            })
          }, 100)
        }

      })
    },
    goView(index) {
      switch (index) {
        case 0:
          this.$router.push('/media/News')
          break;
        case 1:
          this.$router.push('/placard_media_index/outdoors')
          break;
        case 2:
          this.$router.push('/red_talent_index/talent')
          break;
        case 3:
          this.$router.push('/aiNav?digitalHuman')
          break;
        case 4:
          this.$router.push('/product')
          break;
        case 5:
          this.$router.push('/technical')
          break;
        //case 5:
          //this.$router.push('/credible')
          //break;
        case 6:
          this.$router.push('/wordNav')
          break;
        case 7:
          this.$router.push('/aiNav')
          break;
        default:
          break;
      }
    },
    // 去功能选择页面
    async goAiNav() {
      const aiStatus = await goAi()
      console.log('aiStatus', aiStatus);
      if (aiStatus == 'ok') {
        this.$router.push('/aiNav')
      } else {
        return this.$store.state.loginShow = true
      }
    },
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/Product'
</style>